<template lang="pug">
div(class='-m-2 flex flex-wrap' data-testid='textList')
  template(v-for='(letter, index) in letters' :key='index')
    div(v-if='brandIndex[letter]' class='p-3 w-1/2 md:w-1/4 lg:w-1/6')
      div(class='uppercase font-bold text-3xl text-gray-dark') {{ letter }}
      div(v-for='(brand, bIndex) in brandIndex[letter]' :key='bIndex' class='leading-tight mb-1')
        UniversalLink(:link='linkUrl(brand)' class='text-gray-dark') {{ brand.name }}
</template>

<script setup lang="ts">
const { data } = defineProps<{
  data: BrandData[]
}>()

const brandIndex = ref<Record<string, Brand[]>>({})

createLetterGroups()

const letters = computed(() => letterGroups())

function linkUrl(brand: Brand) {
  return `/b/${brand.slug}`
}

function createLetterGroups() {
  if (!data) return
  data.forEach(({ group, name, slug }) => {
    if (!brandIndex.value[group]) brandIndex.value[group] = []
    brandIndex.value[group].push({ name, slug })
  })
}

interface Brand {
  name: string
  slug: string
}

interface BrandData extends Brand {
  group: string
}
</script>
